import { useNavigate } from "react-router-dom";
import "../../styles/Eventcard.css";

const EventCard = ({ event, getEventStatus, formatDate, formatTime }) => {
  const navigate = useNavigate();
  const status = getEventStatus(event.dateFrom, event.dateTo);

  const venueDisplay =
    event.venue || (event.eventLink ? "Online" : "Venue not available");

  return (
    <div className="col-md-6 px-5">
      <div className="card text-white bg-primary px-4 py-3 rounded-4 shadow">
        <div className="row g-0 align-items-center">
          <div className="col-md-7">
            <div className="card-body">
              <h5
                className="card-subtitle mb-1 fw-bold"
                style={{ fontSize: "1rem" }}
              >
                {formatDate(event.dateFrom)}
                {new Date(event.dateFrom).toDateString() !==
                new Date(event.dateTo).toDateString()
                  ? ` → ${formatDate(event.dateTo)}`
                  : ""}
                , {venueDisplay}
              </h5>

              <p className="mb-1">
                <strong>Time:</strong> {formatTime(event.startTime)} -{" "}
                {formatTime(event.endTime)}
              </p>

              <h3 className="card-title mb-1">{event.name}</h3>

              <p className="card-text mb-1">
                <strong>Registrations:</strong>{" "}
                {event.attendeesCount ?? event.attendees?.length ?? 0}
              </p>

              <p className="card-text mb-1">
                <strong>Status:</strong>{" "}
                <span
                  className={
                    status === "Ongoing"
                      ? "text-warning fw-bold"
                      : status === "Completed"
                        ? "text-danger fw-bold"
                        : "text-success fw-bold"
                  }
                >
                  {status}
                </span>
              </p>

              {event.organizers?.length > 0 && (
                <div className="mt-0 d-flex align-items-center flex-wrap gap-0">
                  <strong>Organizers:</strong>
                  {event.organizers.map((org) => (
                    <div
                      key={org.member?.id ?? Math.random()}
                      className="d-flex align-items-center bg-light text-dark px-2 py-1 rounded-pill"
                      style={{ cursor: "pointer" }}
                      onClick={() => navigate(`/members/${org.member?.id}`)}
                      aria-label={`View organizer ${org.member?.firstName} ${org.member?.lastName} profile`}
                      title={`${org.member?.firstName} ${org.member?.lastName}`}
                    >
                      {org.member?.firstName} {org.member?.lastName}
                    </div>
                  ))}
                </div>
              )}

              <button
                className="btn bg-secondary rounded-pill mt-3"
                onClick={() => navigate(`/events/${event.eventId}`)}
                aria-label={`View details for event ${event.name}`}
              >
                View details
              </button>
            </div>
          </div>

          {event.image?.url && (
            <div className="col-md-5 pt-0">
              <img
                src={event.image.url}
                className="img-fluid rounded-4"
                alt={event.name}
                style={{ objectFit: "cover", height: "100%" }}
              />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default EventCard;
